window.Namespace = function(namespace) {
  let parent = window;  // Empezamos con el objeto global `window`
  namespace.split('.').forEach(function(e) {
    parent[e] = parent[e] || {};  // Creamos los espacios de nombres necesarios
    parent = parent[e];  // Actualizamos `parent` al siguiente nivel del espacio de nombres
  });
};
